import React from "react";
import { Box, Container, Grid, Skeleton, styled } from "@mui/material";
import { SectionTitle } from "../../components/home-section-title/HomeSectionTitle";
import { StyledTabs } from "../../components/home-tab/HomeTab";

const SkeletonCard = styled(Box)(({ theme }) => ({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(1),
  overflow: "hidden",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
}));

const BestSellersSkeleton = () => {
  return (
    <Box sx={{ py: 6, backgroundColor: "#fff" }}>
      <Container maxWidth="xl">
        <SectionTitle variant="h2">Best Sellers</SectionTitle>

        <StyledTabs value={0} aria-label="product categories">
          <Skeleton
            variant="rectangular"
            width={100}
            height={48}
            sx={{ borderRadius: 1 }}
          />
          <Skeleton
            variant="rectangular"
            width={100}
            height={48}
            sx={{ borderRadius: 1 }}
          />
        </StyledTabs>

        <Grid container spacing={2.5}>
          {[1, 2, 3, 4, 5].map((item) => (
            <Grid item xs={12} sm={6} md={2.4} key={item}>
              <SkeletonCard>
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={200}
                  sx={{ mb: 1 }}
                />
                <Box sx={{ p: 2 }}>
                  <Skeleton
                    variant="text"
                    width="70%"
                    height={24}
                    sx={{ mb: 1 }}
                  />
                  <Skeleton
                    variant="text"
                    width="50%"
                    height={20}
                    sx={{ mb: 1 }}
                  />
                  <Skeleton
                    variant="text"
                    width="30%"
                    height={20}
                    sx={{ mb: 1 }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width="40%"
                    height={32}
                    sx={{ borderRadius: 1, mt: 2 }}
                  />
                </Box>
              </SkeletonCard>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default BestSellersSkeleton;
